import React, { useMemo, useRef, forwardRef } from 'react'

//style
import ButtonAddNewBigStyle from './style'

const ButtonAddNewBig = forwardRef((props, ref) => {

	//! Button Type
	const btn = useMemo(() => {
        return (
            <ButtonAddNewBigStyle 
                ref={ref}
                type={props.type || 'button'}
                className={`${props.className || ''} cursorPointer`}
                onClick={props.onClick} >
                    <div className='plus'>
                        <svg  width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.9999 1.64001V8.36001M1.63989 5.00002H8.35989" stroke={`white`} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                    {props.children || props.text}
            </ButtonAddNewBigStyle>
        )
	}, [props])

	return btn
})

export default ButtonAddNewBig
